import type { ComponentChildren, JSX } from "preact";
import { Fc2Spinner } from "./Fc2Spinner";

/** Ghost refresh control with inline spinner while `loading`. */
export function Fc2RefreshButton({
  loading,
  onClick,
  disabled,
  title,
  style,
  children,
}: {
  loading: boolean;
  onClick: () => void;
  disabled?: boolean;
  title?: string;
  style?: JSX.CSSProperties;
  children: ComponentChildren;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled ?? loading}
      title={title}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        minWidth: 88,
        justifyContent: "center",
        ...style,
      }}
    >
      {loading ? <Fc2Spinner size={14} label="Refreshing" /> : null}
      {children}
    </button>
  );
}
